import React from 'react';
import { Col, Form, Input, Row, TimePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import { TIME_FORMAT } from '../../../constants';
import './DeliveryForm.scss';
import AddressInput from '../../Inputs/AddressInput';
import isEmpty from 'lodash/isEmpty';
import SitePickerFields from './SitePickerFields';
import PhoneInput from 'react-phone-input-2';

const DeliveryForm = ({ form, order }) => {
  const { t } = useTranslation('orders');

  const handleOnChangeDeliveryFrom = (value) => {
    form.setFieldsValue({ deliveryTimeStart: value });
    if (isEmpty(value) || isEmpty(form.getFieldValue('deliveryTimeEnd'))) {
      resetErrorDeliveryTime();
      return;
    }
    if (form.getFieldValue('deliveryTimeEnd') < value) {
      form.setFields([
        {
          name: 'deliveryTimeStart',
          errors: [t('form.deliveryFromError')],
        },
      ]);
    }
  };

  const handleOnChangeDeliveryTo = (value) => {
    form.setFieldsValue({ deliveryTimeEnd: value });
    if (isEmpty(value) || isEmpty(form.getFieldValue('deliveryTimeStart'))) {
      resetErrorDeliveryTime();
      return;
    }
    if (form.getFieldValue('deliveryTimeStart') > value) {
      form.setFields([
        {
          name: 'deliveryTimeEnd',
          errors: [t('form.deliveryToError')],
        },
      ]);
    }
  };

  const resetErrorDeliveryTime = () => {
    form.setFields([
      {
        name: 'deliveryTimeStart',
        errors: [],
      },
      {
        name: 'deliveryTimeEnd',
        errors: [],
      },
    ]);
  };
  return (
    <div className={`DeliveryForm`}>
      {/* OVO-253 parity — order CREATION is site-first, so editing must offer
          the same choice instead of free text only. */}
      <SitePickerFields
        form={form}
        side="delivery"
        order={order}
        partnerId={order?.partnerRef?.id ?? order?.partnerId}
      />
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label={t('form.deliveryName')}
            name="deliveryName"
            rules={[{ required: true, message: t('common:required') }]}
          >
            <Input placeholder={t('form.deliveryName')} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={t('form.deliveryPhone')} name="deliveryPhone">
            <PhoneInput country={'ch'} prefix="+" specialLabel="" enableSearch disableSearchIcon />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={t('form.deliveryFrom')} name="deliveryTimeStart">
            <TimePicker
              placeholder={t('form.deliveryFrom')}
              format={TIME_FORMAT}
              minuteStep={30}
              style={{ width: '100%' }}
              onChange={handleOnChangeDeliveryFrom}
              onSelect={handleOnChangeDeliveryFrom}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={t('form.deliveryTo')} name="deliveryTimeEnd">
            <TimePicker
              placeholder={t('form.deliveryTo')}
              format={TIME_FORMAT}
              minuteStep={30}
              style={{ width: '100%' }}
              onChange={handleOnChangeDeliveryTo}
              onSelect={handleOnChangeDeliveryTo}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={t('form.deliveryEmail')}
            name="deliveryEmail"
            rules={[{ type: 'email', message: t('common:invalidEmail') }]}
          >
            <Input placeholder={t('form.deliveryEmail')} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={t('form.deliveryAddress')}
            name="deliveryAddress"
            rules={[
              {
                validator: (_, value) => {
                  if (
                    (value?.address && value?.latLng?.lat && value?.latLng?.lng) ||
                    (isEmpty(value?.address) && routePlanType !== 'PDP')
                  ) {
                    return Promise.resolve();
                  }

                  if (isEmpty(value?.address) && routePlanType === 'PDP') {
                    return Promise.reject(new Error(t('common:required')));
                  }

                  return Promise.reject(new Error(t('common:invalid')));
                },
              },
            ]}
          >
            <AddressInput
              placeholder={t('form.deliveryAddress')}
              onSelect={(value) => form.setFieldsValue({ deliveryAddress: value })}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={t('form.deliveryDuration')}
            name="deliveryDuration"
            tooltip={t('form.deliveryDurationTooltip')}
          >
            <Input placeholder={t('form.deliveryDuration')} suffix={t('common:minutes')} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="deliveryNote" label={t('form.deliveryNote')}>
            <Input placeholder={t('common:note')} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default DeliveryForm;
